module.exports = __webpack_public_path__ + "static/mwjerinwinterpatrickatcamp-403d71fbd39583a5bf4403b58bf0b72a.jpg";